import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  FAQSData,
  KeySpecifications,
  contactData,
} from "../../constants/helpAndSupport";
import ContentSection from "./ContentSection";
import PageHeader from "../../common/PageHeader";
import colors from "../../theme/Colours";

const HelpAndSupport: React.FC = () => (
  <>
    <PageHeader title="Support" />

    <Box
      sx={{
        padding: { xs: "16px 16px", sm: "0 28px 28px 28px" },
        background: "#FFFFFF",
      }}
    >
      <Typography
        variant="h5"
        paddingY="25px"
        fontFamily="Roboto"
        fontWeight="400"
        fontSize={{ xs: "12px", sm: "18px" }}
      >
        Hello, how can we help you?
      </Typography>
      <Grid container>
        <Typography
          sx={{
            fontSize: { xs: "12px", sm: "14px" },
            fontWeight: 500,
            color: "#000000",
          }}
        >
          Email Us at{" "}
          <Typography
            component="span"
            sx={{
              color: colors.primaryButtonOrange,
              textDecoration: "underline",
              fontWeight: 500,
              fontSize: { xs: "12px", sm: "14px" },
            }}
          >
            {contactData[0]?.email}
          </Typography>
        </Typography>
      </Grid>
    </Box>
    <Box
      sx={{
        mt: "32px",
        padding: { xs: "16px 16px", sm: "0 28px 45px 28px" },
        background: "#FFFFFF",
        boxShadow: { xs: "none", sm: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" },
      }}
    >
      <Grid pt="50px">
        <Grid size={{ xs: 12, sm: 10 }}>
          <Typography
            variant="h4"
            sx={{
              marginBottom: "20px",
              fontWeight: "700",
              fontSize: { md: "32px", xs: "18px" },
            }}
          >
            {/* &lsquo; for a left single quotation mark (opening apostrophe) */}
            FAQ&lsquo;s
          </Typography>
          <ContentSection
            title="Keg Ordering, Delivery & Payment Process"
            data={FAQSData}
          />
        </Grid>
      </Grid>
      <Grid mt={{ xs: "40px", sm: "120px" }}>
        <Grid size={{ xs: 12, sm: 10 }}>
          <ContentSection
            title="Keg Specifications & Storage"
            data={KeySpecifications}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          backgroundColor: " #F9FAFB",
          margin: "84px 0px 20px 0px",
          padding: "20px",
          borderRadius: "17px",
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "#53686A",
          }}
        >
          Still have questions?
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: "400",
            fontFamily: "Poppins",
            color: "#53686A",
          }}
        >
          Can’t find the answer you’re looking for? Please get in touch with us
          at{" "}
          <Typography
            component="span"
            sx={{ fontWeight: "700", fontSize: "13px", color: "#252525" }}
          >
            {contactData[0]?.email}
          </Typography>
        </Typography>
      </Box>
    </Box>
  </>
);

export default HelpAndSupport;
